<template>
  <div class="container-fluid">
    <div class="row mb-3">
      <div class="col-sm-12 text-center">
        <h1 class="title">
          My Contracts
        </h1>
      </div>
    </div>
    <div class="row">
      <template v-if="contracts.length">
        <div v-for="(item, index) in contracts" :key="index" class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12 d-flex">
                  <div class="product-icon-rounded d-flex justify-content-center align-items-center flex-grow-0 flex-shrink-0 cursor-pointer" style="height: 80px; width:80px;">
                    <svg class="svg-icon svg-icon--product" style="width:3em; height:3em;">
                      <use :xlink:href="require(`@/assets/img/${item.PRODUCT}.svg`) + `#${item.PRODUCT}`"></use>
                    </svg>
                  </div>
                  <div class="flex-grow-1 flex-shrink-1 ml-3 align-self-center">
                    <div class="row">
                      <div class="col-lg-3">
                        <h3>{{ item.MANUFACTURER_DESC }} {{ item.MODEL_DESC }}</h3>
                        <h4>{{ item.LICENSE_PLATE }}</h4>
                      </div>
                      <div class="col-lg-9">
                        <h2>{{ item.CS_PROPOSAL.TITLE }} - {{ $u.formatMoney(item.CS_PROPOSAL.PREMIUM) }}</h2>
                        <div v-popper="{ placement: 'bottom-end' }">
                          <a href="javascript:;" class="" popper-trigger>
                            <span>
                              {{ item.CS_PROPOSAL.CT_COVERS.length + item.CT_COVERS.length }} Covers
                              <!-- <i class="mdi mdi-chevron-down"></i> -->
                            </span>
                          </a>
                          <div class="dropdown-menu dropdown-menu-right p-3" popper>
                            <div :class="['row', item.CT_COVERS.length && 'pb-2 mb-2 border-bottom']">
                              <div class="col">
                                <ul class="pl-0 mb-0 list-unstyled">
                                  <template v-for="coverItem in item.CS_PROPOSAL.CT_COVERS">
                                    <li :key="coverItem.TITLE">
                                      <i class="mdi mdi-check-bold text-success"></i> {{coverItem.TITLE}}
                                    </li>
                                  </template>
                                </ul>
                              </div>
                            </div>
                            <div v-if="item.CT_COVERS.length" class="row">
                              <div class="col">
                                <h6 class="mb-1">Optional Covers</h6>
                                <ul class="pl-0 mb-0 list-unstyled">
                                  <template v-for="coverItem in item.CT_COVERS">
                                    <li :key="coverItem.TITLE">
                                      <i class="mdi mdi-check-bold text-success"></i> {{coverItem.TITLE}}
                                    </li>
                                  </template>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <pre>{{ item }}</pre> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="col-sm-12 text-center">
          <h2>Currently there is no contract</h2>
        </div>
      </template>
    </div>
    <loader v-if="loading" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Loader from '@/components/Loader.vue';

export default {
  name: 'MyContracts',
  components: {
    Loader,
  },
  data() {
    return {
      loading: false
    };
  },
  async created() {
    this.loading = true;
    await this.loadContracts();
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  },
  computed: {
    ...mapState({
      contracts: (state) => state.contract.contracts
    })
  },
  methods: {
    ...mapActions('contract', ['getContractAction']),
    async loadContracts() {
      await this.getContractAction();
    }
  },
};
</script>
